import BaseSuperApp from '@/modules/base-superapp/App'
import { Authentication } from './shahrzad-assets/shared_components/Authentication'
import AuthRouting from './routing/AuthRouting'
import { Navigate, Route, Routes } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import CustomLoading from './shahrzad-assets/shared_components/CustomLoading'
import basePathes from '@/modules/pathes';
import ErrorBoundary from './components/ErrorBoundary'
import { pathes } from './modules/marketplace/routing/pathes'
import replaceParameters from './shahrzad-assets/shared-utils/replaceParameters'
const AbtTicket = lazy(()=>import('@/modules/abt-ticket/App'));
const Marketplace = lazy(()=>import('@/modules/marketplace/App'));
const TechnicalDiagnosis = lazy(()=>import('@/modules/technical-diagnosis/App'));
const FeedPwa = lazy(()=>import('@/modules/feed-pwa/App'));
const QuestionnarePwa = lazy(()=>import('@/modules/questionnaire-pwa/App'));
const SpecialGroups = lazy(()=>import('@/modules/special-groups/App'));
const TaxiDriver = lazy(()=>import('@/modules/taxi-driver/App'));
const TaxiPassenger = lazy(()=>import('@/modules/taxi-passenger/App'));
const VehicleProfile = lazy(()=>import('@/modules/vehicle-profile/App'));
const VodPlatform = lazy(()=>import('@/modules/vod-platform/App'));
const OperatingService = lazy(()=>import('@/modules/operating-service/App'));
const DriverPwa = lazy(()=>import('@/modules/driver-pwa/App'));

const MarketplaceOrders = () => {
  const selectionContextString = localStorage.getItem('selections-context')
  const selectionContext = JSON.parse(selectionContextString)
  const { instituteId, storeTypeName } = selectionContext
  return (
    <>
      <Navigate
        to={replaceParameters(pathes.BASE_PATH + pathes.ORDERS, {
          instituteId,
          storeTypeName,
        })}
      />
    </>
  )
} 

const App = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<CustomLoading />}>
        {/* <BaseRoutes /> */}
        <AuthRouting />
        <Authentication>
          <Routes>
            <Route path='/*' element={<BaseSuperApp />} />
            <Route path={`${basePathes.abtTicket}/*`} element={<AbtTicket />} />
            <Route path={`${basePathes.feedPwa}/*`} element={<FeedPwa />} />
            <Route path={'/marketplace/orders'} element={<MarketplaceOrders />} />
            <Route path={`${basePathes.marketplace}/*`} element={<Marketplace />} />
            <Route path={`${basePathes.questionarePwa}/*`} element={<QuestionnarePwa />} />
            <Route path={`${basePathes.specialGroups}/*`} element={<SpecialGroups />} />
            <Route path={`${basePathes.taxiDriver}/*`} element={<TaxiDriver />} />
            <Route path={`${basePathes.taxiPassenger}/*`} element={<TaxiPassenger />} />
            <Route path={`${basePathes.technicalDiagnosis}/*`} element={<TechnicalDiagnosis />} />
            <Route path={`${basePathes.vehicleProfile}/*`} element={<VehicleProfile />} />
            <Route path={`${basePathes.vodPlatform}/*`} element={<VodPlatform />} />
            <Route path={`${basePathes.operatingServices}/*`} element={<OperatingService />} />
          </Routes>
        </Authentication>
        <Routes>
          <Route path={`${basePathes.driverPwa}/*`} element={<DriverPwa />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default App
